import { InstitutionService as EsInstitutionService } from '@examsoft/es-login';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from "rxjs/operators";
import { AuthService } from '@examsoft/es-login';

@Injectable({ providedIn: 'root' })
export class InstitutionService {

  constructor(
    private esInstitution: EsInstitutionService,
    private authService: AuthService,
    private http: HttpClient
  ) {
  }

  public httpOptions(): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'Authorization': this.authService.getJwt(),
        'Content-Type': 'application/json'
      })
    };
  }

  find(uuid){
    return this.esInstitution.searchByUuid(uuid).then( school => {
      let data = { ...school };
      return {
        institutionId: data.uuid,
        institutionName: data.institution,
        portal: data.portal
      }
    })
  }

  getInstitutions(app: 'exam-id'|'exam-monitor'|'exam-now'){
    let url = `${environment.urls.usage}/${app}/institutions`;
    return this.http.get(url, this.httpOptions()).pipe(map( ( data: any[] ) => {
      return data.map( data => this.getDetails(data))
    }));
  }

  getAll(){
    return this.esInstitution.get().then( result => {
      return result.map( data => {
        return {
          uuid: data.uuid,
          id: data.id,
          name: data.name,
        };
      });
    });
  }


  private getDetails(data){
    return {
      id: data.instituteId,
      name: data.instituteName,
      enddate: data.billingEndDate,
      startdate: data.billingStartDate
    }
  }
}
